module.exports = __webpack_public_path__ + "images/zhongduan1.jpg?v=fcf4806f";


/*****************
 ** WEBPACK FOOTER
 ** ./src/images/home/quanjing/index/zhongduan1.jpg
 ** module id = 114
 ** module chunks = 1 2
 **/